<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type Ref } from 'vue'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import { Loader } from 'lucide-vue-next'
import { type ButtonVariants, buttonVariants } from '.'

interface Props extends PrimitiveProps {
    variant?: ButtonVariants['variant']
    size?: ButtonVariants['size']
    as?: string
    loading?: boolean
    disabled?: boolean | Ref<true> | Ref<false> | Ref<boolean>
    type?: 'button' | 'submit' | 'reset' | null
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'default',
    size: 'default',
    as: 'button',
    loading: false,
    disabled: false,
    type: 'button',
    class: '',
})
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(buttonVariants({ variant, size }), props.class)"
        :disabled="loading || disabled"
        :type="type"
    >
        <Loader v-if="loading" class="mr-2 h-4 w-4 shrink-0 opacity-50 animate-spin" />
        <slot />
    </Primitive>
</template>
